import { render } from "./auditionDetail.vue?vue&type=template&id=47cc5f57&scoped=true"
import script from "./auditionDetail.vue?vue&type=script&lang=js"
export * from "./auditionDetail.vue?vue&type=script&lang=js"

import "./auditionDetail.vue?vue&type=style&index=0&id=47cc5f57&lang=sass&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cc5f57"]])

export default __exports__